<template>
    <div class="invitation-wrapper">
        <!--        <header-modular :back="'返回登录'" :url="'/login'"></header-modular>-->

        <div class="bg-invitation">
            <h1>{{ org.name }}</h1>
            <div class="flex justify-center ">
                <img alt="" src="../assets/img/invitation-title.png">
            </div>
            <div class="bg-box">
                <div class="bg-box2">
                    <div class="tab-box flex align-center justify-between">
                        <span :class="{'active':type === 1}" @click="type = 1">会员申请</span>
                        <span :class="{'active':type === 2}" @click="type = 2">单位介绍</span>
                    </div>
                    <div v-show="type === 1">
                        <div v-html="agreement" v-if="isYinYuePower"></div>
<!--                        <div class="flex align-center justify-center margin-bottom-sm" v-if="isYinYuePower">-->
<!--                            <el-checkbox v-model="checked"></el-checkbox>-->
<!--                            <span class="margin-left-xs" style="cursor: pointer"-->
<!--                                  @click="centerDialogVisible = true"> 请仔细阅读《入会须知》</span>-->
<!--                        </div>-->
                        <el-form ref="ruleForm" :model="infoForm" class="ruleForm" label-position="top" label-width="auto">
                            <el-row :gutter="20"  v-if="!isSpeRights">
                                <el-form-item label="会员类型">
                                    <el-radio-group v-model="infoForm.type" @change="typeChange">
                                        <el-radio v-if="show_geren_register && user_type_sort" :label="1">{{ oid === 952 ? '单位会员' : '个人会员'}}</el-radio>
                                        <el-radio v-if="show_org_register" :label="0">{{ oid === 952 ? '医废签约单位' : '单位会员'}}</el-radio>
                                        <el-radio v-if="show_geren_register  && !user_type_sort" :label="1">{{ oid === 952 ? '单位会员' : '个人会员'}}</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-row>
                            <template  v-if="isShowRights">
                                <div class="detail margin-bottom-sm" v-html="rights_info.spe_content" v-if="isSpeRights"></div>
                                <div class="detail margin-bottom-sm" v-html="rights_info.content" v-else></div>
                            </template>
                            <div class="expend" @click="isShowRights = !isShowRights" v-if="rights_info.is_show">{{isShowRights ? '收起' : '查看会员权益'}}
                                <i class="el-icon-arrow-up" v-if="isShowRights"></i>
                                <i class="el-icon-arrow-down" v-else></i>
                            </div>
                            <el-row :gutter="20">
                                <el-col v-for="(item,index) in infoForm.list"
                                        :key="index"
                                        :span="(item.type === 2 || item.type ===6|| item.type ===7 || item.title.length >10) ? 24 : 12">
                                    <el-form-item v-if="item.type === 1 && (item.isShow === undefined || item.isShow)" :label="item.title"
                                                  :prop="'list.' + index + '.answer'"
                                                  :rules="item.rules">
                                        <el-input v-model="item.answer" :disabled="item.disabled"
                                                  :placeholder="item.placeholder || '请输入' + item.title"></el-input>
                                    </el-form-item>
                                    <el-form-item v-if="item.type === 2 && (item.isShow === undefined || item.isShow) " :label="item.title"
                                                  :prop="'list.' + index + '.answer'"
                                                  :rules="item.rules">
                                        <el-input v-model="item.answer" :placeholder="'请输入' + item.title"
                                                  :rows="5" type="textarea"></el-input>
                                    </el-form-item>
                                    <el-form-item v-if="item.type === 3 && (item.isShow === undefined || item.isShow) && !item.hide" :label="item.title"
                                                  :prop="'list.' + index + '.answer'"
                                                  :rules="item.rules">
                                        <div v-if="item.field && item.field === 'rankId'">
                                            <el-select v-model="item.answer" :placeholder="'请选择' + item.title"
                                                       class="w-all"
                                                       @change="setLevel" :disabled="item.disabled">
                                                <el-option v-for="option in item.options" :key="option.value"
                                                           :label="option.label"
                                                           :value="option.value"></el-option>
                                            </el-select>
                                        </div>
                                        <div v-else>
                                            <el-select v-model="item.answer" :placeholder="'请选择' + item.title"
                                                       class="w-all"
                                                       clearable :disabled="item.disabled">
                                                <el-option v-for="option in item.options" :key="option.value"
                                                           :label="option.label"
                                                           :value="option.value"></el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                    <el-form-item v-if="item.type === 4 && (item.isShow === undefined || item.isShow)" :label="item.title"
                                                  :prop="'list.' + index + '.answer'"
                                                  :rules="item.rules">
                                        <el-select v-model="item.answer" :placeholder="'请选择' + item.title" class="w-all"
                                                   clearable multiple>
                                            <el-option v-for="option in item.options" :key="option.value"
                                                       :label="option.label"
                                                       :value="option.value"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item v-if="item.type === 5 && (item.isShow === undefined || item.isShow)" :label="item.title"
                                                  :prop="'list.' + index + '.answer'"
                                                  :rules="item.rules">
                                        <el-cascader
                                            v-model="item.answer"
                                            :options="options"
                                            expand-trigger="hover"
                                            filterable
                                            placeholder="请选择单位所在地"
                                            style="width: 100%;"
                                        >
                                        </el-cascader>
                                    </el-form-item>
                                    <el-form-item v-if="item.type === 6 && (item.isShow === undefined || item.isShow)" :label="item.title"
                                                  :prop="'list.' + index + '.answer'"
                                                  :rules="item.rules">
                                        <infoUpFile :file="item.answer" :index="index" :limit="item.limit"
                                                    :type="item.type"
                                                    @saveFile="saveFile"/>
                                    </el-form-item>
                                    <el-form-item v-if="item.type === 7 && (item.isShow === undefined || item.isShow)" :label="item.title"
                                                  :prop="'list.' + index + '.answer'"
                                                  :rules="item.rules">
                                        <infoUpFile :file="item.answer" :index="index" :limit="item.limit"
                                                    :type="item.type"
                                                    @saveFile="saveFile"/>
                                    </el-form-item>
                                    <el-form-item v-if="item.type === 8 && (item.isShow === undefined || item.isShow)" :label="item.title" :prop="'list.' + index + '.answer'"
                                                  :rules="item.rules">
                                        <el-date-picker
                                            v-model="item.answer"
                                            placeholder="请选择日期"
                                            style="width: 100%"
                                            type="date"
                                            value-format="yyyy-MM-dd">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <template  v-if="register_pay" >
                                        <div class="flex justify-center font-size-lg margin-bottom-sm">
                                            需缴纳会费 <b class="padding-lr-xs font-size-xs" style="color: #ff0000">{{
                                                money
                                            }}</b> 元
                                        </div>
                                        <el-form-item label="支付方式">
                                            <el-radio-group v-model="pay_type">
                                                <el-radio v-if="wechatConfigState" :label="0">微信支付</el-radio>
                                                <el-radio :label="1">公账支付</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </template>
                                    <el-form-item v-if="pay_type === 1">
                                        <div class="transfer-info flex flex-direction">
                                            <div><span>开户行：</span>{{ transfer_info.kaihuhang }}</div>
                                            <div><span>收款单位：</span>{{ transfer_info.shoukuandanwei }}</div>
                                            <div><span>银行卡号：</span>{{ transfer_info.kahao }}</div>
                                        </div>
                                    </el-form-item>
                                    <div class="flex align-center justify-center margin-bottom-sm" v-if="!isYinYuePower">
                                        <el-checkbox v-model="checked"></el-checkbox>
                                        <span class="margin-left-xs" style="cursor: pointer"
                                              @click="centerDialogVisible = true"> 请仔细阅读《入会须知》</span>
                                    </div>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label-width="0">
                                        <div class="flex justify-center">
                                            <el-button class="blue-btn big-btn" @click="saveForm('ruleForm')">申请加入
                                            </el-button>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <div class="info-tip">默认账号、密码均为联系人手机号，待管理员审核通过后可登录系统、修改密码。</div>
                                    <div class="info-tip">填写过程有任何问题请联系：{{ kefu_tel || service_phone }}</div>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div v-show="type === 2" class="desc-box" v-html="org.content"></div>

                </div>
            </div>
        </div>


        <footer-modular :state="false"></footer-modular>
        <el-dialog
            :visible.sync="centerDialogVisible"
            center
            title="入会须知"
            width="60%">
            <div v-html="agreement"></div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
              </span>
        </el-dialog>
        <div v-show="qrcodeUrl" class="qrcode">
            <qrcode v-if="qrcodeUrl"
                    :size="250"
                    :text="qrcodeUrl"
                    class="margin-top-xl">
            </qrcode>
            <p class="tips">请使用微信扫码支付</p>
            <el-button circle icon="el-icon-close" type="info" @click="cancel"></el-button>
        </div>
        <payment-transfer-dialog :applyDialogVisible="dialogTransferVisible" @cancelDialog="cancelDialog"
                                 @fileSuccess="fileSuccess"></payment-transfer-dialog>
    </div>
</template>

<script>
import infoUpFile from "@/components/InfoUpFile";
import FooterModular from "@/components/FooterLinkModular.vue";
import {regionData} from "element-china-area-data";
import {
    getApplyRankList,
    getApplyRankListFh,
    getCompanyUserMoreJson,
    getCompanyUserMoreJsonFh, getUserTypeDesc,
    memberApply,
    memberApplyFh,
    userGetSelfBaseInfo
} from "@/api/login";
import {isYinYuePower, patternChange} from "../utils/utils";
import {service_phone} from "../utils/const";
import {
    checkUserRegisterPayState,
    checkWebSetInfo,
    checkWechatPaymentInfo,
    getDuiGongData,
    getfenhuiList
} from "../api/login";
import PaymentTransferDialog from "../components/PaymentTransferDialog";
import Qrcode from 'vue-qr'

export default {
    name: "invitation",
    data() {
        return {
            service_phone: service_phone,
            oid: 1,
            type: 1,
            invType: 0,
            kefu_tel: '',
            // money: '0.00',
            basicInfo: {
                userMoreJsonOrg: '',
                userMoreJsonPersona: ''
            },
            infoForm: {
                type: 1,
                list: [
                ],
            },
            levelList: [],
            organizs: [],
            checked: false,
            options: regionData,
            org: {
                name: '',
                content: '',
            },
            centerDialogVisible: false,
            agreement: '',
            userMoreJson: [],

            user_type_sort: 1,
            show_geren_register: 1,
            show_org_register: 1,

            register_pay: 0,
            transfer_info: [],
            wechatConfigState: 0,
            pay_type: 0,

            timer: '',
            order_no: '',
            qrcodeUrl: '',
            dialogTransferVisible: false,

            isYinYuePower:false,

            rights_info:'',
            isShowRights:false,
            isSpeRights:false,

            share_id:''
        }
    },
    created() {
        this.invType = Number(this.$route.query.type || 0)
        if(this.$route.query.user_type){
            this.isSpeRights = true
            this.infoForm.type = Number(this.$route.query.user_type) - 1
        }
        this.oid = Number(this.$route.params.id || 0)
        this.share_id = this.$route.query.share_id
        this.init()
        this.getInformation()
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        money() {
            if (this.register_pay) {
                let find = this.infoForm.list.find(f=> f.field === 'rankId')
                let money = this.levelList.find(f => find.answer === f.id)
                if (money) {
                    return money.price;
                } else {
                    return '0.00'
                }
            } else {
                return '0.00'
            }
        }
    },
    destroyed() {
        clearInterval(this.timer);
    },
    components: {PaymentTransferDialog, FooterModular, infoUpFile, qrcode: Qrcode},
    methods: {
        async init() {
            let _data = await checkWechatPaymentInfo(this.$route.params.id, this.invType ? this.$route.params.id : '')
            if (_data.status === 200) {
                this.wechatConfigState = _data.data
                if(!this.wechatConfigState) this.pay_type = 1
            }
            _data = await getDuiGongData(this.$route.params.id, this.invType ? this.$route.params.id : '')
            if (_data.status === 200) {
                this.transfer_info = _data.data
            }
        },
        //  保存表单
        saveForm(formName) {
            this.$refs[formName].clearValidate()
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (!this.checked) return this.$message.error('请仔细阅读并同意《入会须知》！')
                    this.sureSave()
                } else {
                    this.$message.error('信息填写有误，请确认！')
                }
            });

        },
        async sureSave() {
            if (this.register_pay) {
                if (this.pay_type) {
                    this.dialogTransferVisible = true
                } else {
                    let _state = this.invType ?
                        await memberApplyFh(JSON.stringify(this.infoForm.list), this.$route.params.id, this.infoForm.type + 1, 1, '',this.share_id)
                        : await memberApply(JSON.stringify(this.infoForm.list), this.$route.params.id, this.infoForm.type + 1, 1, '',this.share_id)
                    if (_state.status === 200) {
                        this.wxPay(_state)
                    }
                }
            } else {
                let _state = this.invType ? await memberApplyFh(JSON.stringify(this.infoForm.list), this.$route.params.id, this.infoForm.type + 1, 0, '',this.share_id)
                    : await memberApply(JSON.stringify(this.infoForm.list), this.$route.params.id, this.infoForm.type + 1, 0, '',this.share_id)
                if (_state.status === 200) {
                    this.$alert('恭喜您申请成功，请等待单位审核', '温馨提示', {
                        confirmButtonText: '确定',
                        center: true,
                        callback: () => {
                            this.$router.push('/')
                        }
                    });

                }
            }


        },
        //  同步附件信息
        saveFile(val) {
            const _index = val[0]
            this.infoForm.list[_index].answer = val[1]
            this.$set(this.infoForm.list, _index, this.infoForm.list[_index])

        },
        setLevel(val) {
            this.levelList.map(item => {
                if (item.id === val) {
                    this.money = item.price
                }
            })
        },
        //  获取表单
        async getInformation() {
            let _data = this.invType ? await getCompanyUserMoreJsonFh(this.$route.params.id) :
                await getCompanyUserMoreJson(this.$route.params.id)
            this.org = {
                name: _data.data.orgData.morgname,
                content: _data.data.orgData.morgdesc,
            }
            this.agreement = _data.data.ruHuiContent
            this.kefu_tel = _data.data.kefu_tel
            this.userMoreJson.push(_data.data.userMoreJson ? _data.data.userMoreJson.user_more_json : JSON.stringify(this.infoForm))
            this.userMoreJson.push(_data.data.userPersonalMoreJson ? _data.data.userPersonalMoreJson.user_more_json : '[]')

            if (this.user && this.user.login_type === 1) {
                let _data = await userGetSelfBaseInfo()
                _data.data.userMoreJsonOrg = _data.data.userMoreJsonOrg ?
                    JSON.parse(_data.data.userMoreJsonOrg) : [{title: '法人联系电话', answer: this.user.phone}]
                _data.data.userMoreJsonPersonal = _data.data.userMoreJsonPersonal ?
                    JSON.parse(_data.data.userMoreJsonPersonal) : [{title: '会员电话', answer: this.user.phone,}]
                this.basicInfo = _data.data
            }
            _data = await checkWebSetInfo(this.invType ? '' : this.$route.params.id, this.invType ? this.$route.params.id : '')
            this.register_pay = _data.data.register_pay
            if(!this.register_pay) this.pay_type = 0
            if(isYinYuePower( _data.data.orgid)) {
                this.isYinYuePower = true
                this.checked = true
            }
            this.show_geren_register = _data.data.show_geren_register
            this.show_org_register = _data.data.show_org_register
            if (!this.isSpeRights){
                this.infoForm.type = _data.data.user_type_sort ?  _data.data.user_type_sort.split(',').map(Number)[0] : 1
                this.user_type_sort = this.infoForm.type
                if (!this.show_org_register && !this.user_type_sort) this.infoForm.type = 1 //不显示单位申请时 自动转给个人
                if (!this.show_geren_register && this.user_type_sort) this.infoForm.type = 0 //不显示个人申请时 自动转给单位
            }
            await this.getLevel()
        },
        showDetail(obj) {
            if (obj){
                obj.map(item => {
                    this.infoForm.list.map(items => {
                        if ((item.title === items.title || (item.field || '') === items.field || items.field === item.title) && (item.title !== '会员等级')) {
                            items.answer = item.answer
                            if (item.title === '法人联系电话' || item.title === '会员电话') {
                                items.disabled = true
                            }
                        }
                        if (items.title === '会员等级' && this.isSpeRights && this.infoForm.type === 0){
                            items.answer = 363
                            items.disabled = true
                        }
                    })
                })
            }else{
                this.infoForm.list.map(items => {
                    if (items.title === '会员等级' && this.isSpeRights && this.infoForm.type === 0){
                        items.answer = 363
                        items.disabled = true
                    }
                })
            }

        },
        setJSONData() {
            this.infoForm.list = JSON.parse(this.userMoreJson[this.infoForm.type])
            if (this.infoForm.list.length > 0) {
                this.infoForm.list = patternChange(this.infoForm.list, this.levelList, this.org.name, this.invType ? [] : this.organizs, this.invType ? this.$route.params.id : 0)
                if (this.infoForm.type === 0) {
                    this.showDetail(this.basicInfo.userMoreJsonOrg)
                } else {
                    this.showDetail(this.basicInfo.userMoreJsonPersonal)
                }
            }
        },
        typeChange() {
            this.isShowRights = false
            this.rights_info = ''
            this.getLevel()
        },
        //  获取会员等级列表
        async getLevel() {
            let _data = this.invType ? await getApplyRankListFh(this.$route.params.id,Number(this.infoForm.type) + 1) :
                await getApplyRankList(this.$route.params.id,1,Number(this.infoForm.type) + 1)
            _data.data.map(item => {
                item.value = item.id
                item.label = item.name
            })
            this.levelList = _data.data
            _data = await getfenhuiList(this.invType ? '' : this.$route.params.id, this.invType ? this.$route.params.id : '')
            _data.data.map(item => {
                item.value = item.id
                item.label = item.name
            })
            this.organizs = _data.data
            this.setJSONData()
            _data = await getUserTypeDesc(this.$route.params.id,Number(this.infoForm.type) + 1)
            if (_data.data.user_type === Number(this.infoForm.type) + 1)this.rights_info = _data.data
        },
        async wxPay(_data) {
            if (_data.status === 200) {
                this.order_no = _data.data.order_number
                this.qrcodeUrl = _data.data.url
                let _this = this
                this.timer = setInterval(function () {
                    //执行内容
                    _this.checkPayState()
                }, 3000);
            }
        },
        async checkPayState() {
            let _data = await checkUserRegisterPayState(this.order_no)
            if (_data.status === 200) {
                if (_data.data) {
                    this.qrcodeUrl = ''
                    this.order_no = ''
                    clearInterval(this.timer);
                    this.$alert('恭喜您申请成功，请等待单位审核', '温馨提示', {
                        confirmButtonText: '确定',
                        center: true,
                        callback: () => {
                            this.$router.push('/')
                        }
                    });
                }
            }
        },
        cancel() {
            this.qrcodeUrl = ''
            clearInterval(this.timer);
        },
        watchState(state) {
            this.dialogSuccessVisible = false;
            if (state) this.toBack()
        },
        //  上传文件
        async fileSuccess(val) {
            let _data = this.invType ? await memberApplyFh(JSON.stringify(this.infoForm.list), this.$route.params.id, this.infoForm.type + 1, 2, val.file_path,this.share_id)
                : await memberApply(JSON.stringify(this.infoForm.list), this.$route.params.id, this.infoForm.type + 1, 2, val.file_path,this.share_id)
            if (_data.status === 200) {
                this.order_no = ''
                this.$alert('恭喜您申请成功，请等待单位审核', '温馨提示', {
                    confirmButtonText: '确定',
                    center: true,
                    callback: () => {
                        this.$router.push('/')
                    }
                });
                this.dialogTransferVisible = false
            }
        },
        cancelDialog() {
            clearInterval(this.timer);
            this.dialogTransferVisible = false
        },
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.invitation-wrapper {
    .bg-invitation {
        width: 100%;
        min-height: 100vh;
        padding: 80px;
        background: url(../assets/img/invitation-bg.jpg) #587fb0 no-repeat top center;
        background-size: 100%;

        h1 {
            text-align: center;
            font-size: 36px;
            line-height: 48px;
            letter-spacing: 1px;
            color: #ffffff;
            margin-bottom: 20px;
        }
    }

    .info-tip {
        text-align: center;
        font-size: 20px;
        color: red;
        font-weight: bold;
        margin-top: 20px;
    }

    .transfer-info {
        border: solid 1px #0a2240;
        padding: 30px;
        font-size: 16px;

        span {
            color: #333333;
        }
    }

    .expend{
        text-align: center;
        background: #0d7fd766;
        padding: 10px;
        color: #ffffff;
        cursor: pointer;
        margin-bottom: 20px;
    }

    .bg-box {
        width: 978px;
        margin: 40px auto;
        min-height: 454px;
        background-color: #0a2240;
        border-radius: 20px;

        .bg-box2 {
            width: 934px;
            position: relative;
            top: -30px;
            margin: 0 auto;
            padding: 30px;
            min-height: 508px;
            background-image: linear-gradient(147deg,
                #83b7e3 0%,
                #c1dbf1 37%,
                #ffffff 100%);
            border-radius: 20px;

            &:before {
                position: absolute;
                top: 0;
                left: 472px;
                transform: translate(-50%, 0);
                content: '';
                width: 0;
                height: 0;
                border-left: 20px solid transparent;
                border-right: 20px solid transparent;
                border-top: 20px solid rgb(40, 61, 95);
            }

            .tab-box {
                width: 190px;
                height: 50px;
                margin: 0 auto 30px;
                padding: 9px;
                background-color: #0a2240;
                border-radius: 25px;

                span {
                    display: block;
                    width: 84px;
                    height: 38px;
                    text-align: center;
                    line-height: 38px;
                    font-size: 16px;
                    color: #ffffff;
                    border-radius: 19px;
                    cursor: pointer;

                    &.active {
                        color: #0a2240;
                        background-color: #eef8ff;
                    }
                }
            }

            .desc-box {
                font-size: 16px;
                line-height: 200%;
                word-break: break-all;
            }
        }
    }

    .qrcode {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: #00000099;
        text-align: center;
        z-index: 99;

        .tips {
            font-size: 16px;
            color: white;
            margin: 30px;
        }
    }
}
</style>
